var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TermsOfServiceApp',{attrs:{"version":_vm.version,"language":_vm.$i18n.locale},on:{"isLoading":function($event){return _vm.$emit('isLoading', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }